/**
 * The URL param every view switch stores its choice in. One key app-wide: a page has at most one
 * control answering "how am I looking at this list". `useFilterPersistence` treats it as transient,
 * so a view picked months ago never comes back on a fresh visit.
 */
export const VIEW_PARAM_KEY = 'view';

/**
 * For a list table's `preservedParamKeys`, which a list table needs for any param the page owns:
 * `compareSearchParams` diffs the WHOLE URL param set against the filter state, so a param the table
 * does not know about would leave it permanently out of step and refetching. Shared constant because
 * that prop keys a callback inside the filter hook.
 */
export const VIEW_PRESERVED_PARAM_KEYS = [VIEW_PARAM_KEY] as const;
